import { API } from "./API";

export const SendingReportAPI = {

  GetUserGroupRelatedLoginName: async (groupId) => {

    let data = JSON.stringify({
      requestValue: {
        groupId: groupId
      },
    })

    return await API.post(`SendingReport/GetUserGroupRelatedLoginName`, data);
  },

  GetUserEuIdByLoginName: async (loginName) => {
    let data = JSON.stringify({
      requestValue: {
        loginName: loginName
      },
    });

    return await API.post(`SendingReport/GetUserEuIdByLoginName`, data);
  },

  GetSenderListOfSelectedLoginName: async (loginName) => {

    let data = JSON.stringify({
      requestValue: {
        loginName: loginName
      },
    })

    return await API.post(`SendingReport/GetSenderListOfSelectedLoginName`, data);
  },

};